import React from 'react';
import InputGroup from '@bonprix/pattern-library/templates/input/Group.jsx';
import Select from '@bonprix/pattern-library/templates/input/Select.jsx';
import Label from '@bonprix/pattern-library/templates/input/Label.jsx';
import ChangeItemLandmarks from './changeItemLandmarks.js';
import findCorrectDigistyleId from '../../helper/find-digistyle-helper.js';
import Messages from '../messages.js';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';

export default function ItemOptionSelection({
                                                label,
                                                placeHolderText,
                                                options,
                                                selectedItemOption = null,
                                                isColli,
                                                isError,
                                                layerOrigin,
                                                channelId,
                                                item,
                                                product,
                                                selectedItem,
                                                setSelectedItemOption,
                                                setNotifiable,
                                                setIsItemOptionError
                                            }) {
    const isSingleSize = options.length === 1;

    if (isColli) {
        return <input type="hidden" name="itemOption" value={selectedItemOption.id} />;
    }

    if (isSingleSize) {
        return <input type="hidden" name="size" value={options[0].id} />;
    }

    const onChangeItemOption = (itemOptionId) => {
        const itemIdAsNumber = parseInt(itemOptionId, 10);
        const itemOption = selectedItem.itemOptions.find((option) => option.id === +itemIdAsNumber);
        const notifiable = itemOption?.availabilityType === 'temp';

        setSelectedItemOption(itemOption);
        setNotifiable(notifiable);
        setIsItemOptionError(false);

        ChangeItemLandmarks.sendOnChangeItemOptionClickLandmark(
            layerOrigin,
            itemOption,
            selectedItem.itemNumber,
            channelId,
            item,
            findCorrectDigistyleId(item),
            product.id
        );

        MessageBroker.publish(Messages.LAYER.CHANGE_ITEM_AVAILABILITY_REMINDER, {
            notifiable,
            itemOption: itemOption,
            item: selectedItem
        });
    };

    const itemOptionNodes = options.map(({id, name, availabilityStatus, showAvailabilityStatus}) => {
        const text = showAvailabilityStatus ? `${name} (${availabilityStatus})` : name;
        return (
            <option key={id} value={id}>
                {text}
            </option>
        );
    });

    return (
        <div className="change-item__selection">
            <InputGroup className="change-item__selection-input-group" error={isError}>
                <Label className="input-group__label">{label}</Label>
                <Select
                    name="size"
                    value={selectedItemOption ? selectedItemOption?.id : ''}
                    onChange={(e) => onChangeItemOption(e.target.value)}
                    placeholder={placeHolderText}
                >
                    {itemOptionNodes}
                </Select>
            </InputGroup>
        </div>
    );
}
